<script>
import { events } from "./bus";
const pointerSize = 4;
const directions = {
  left: [-1, 0],
  right: [1, 0],
  top: [0, 1],
  bottom: [0, -1],
  bottomsidebar: [0, -1],
  rightPricing: [1.05, 0],
};
export default {
  name: "Popover",
  props: {
    name: {
      type: String,
      required: true
    },
    width: {
      type: [Number, String],
      default: 180
    },
    maxWidth: {
      type: [Number, String],
      default: 190
    },
    pointer: {
      type: Boolean,
      default: true
    },
    event: {
      type: String,
      default: "click"
    },
    anchor: {
      type: Number,
      default: 0.5,
      validator: v => v >= 0 && v <= 1
    },
    delay: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ""
    },
    paddingLeft: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      positionClass: "",
      position: {
        left: 0,
        top: 0
      },
      runner: null
    };
  },
  computed: {
    showEventName() {
      return `show:${this.event}`;
    },
    hideEventName() {
      return `hide:${this.event}`;
    },
    className() {
      return ["vue-popover", this.pointer && this.positionClass];
    },
    style() {
      return {
        width: `${this.width}${typeof this.width == "number" ? "px" : ""}`,
        'max-width': `${this.maxWidth}${typeof this.maxWidth == "number" ? "px" : ""}`,
        ...this.position
      };
    }
  },
  mounted() {
    events.$on(this.showEventName, this.showEventListener);
    events.$on(this.hideEventName, this.hideEventListener);
  },
  beforeDestroy() {
    events.$off(this.showEventName, this.showEventListener);
    events.$off(this.hideEventName, this.hideEventListener);
  },
  methods: {
    showEventListener(event) {
      if (this.visible) {
        events.$emit(this.hideEventName);
        return;
      }
      this.$nextTick(() => {
        let { target, name, position, delay } = event;
        window.clearTimeout(this.runner);
        if (name === this.name) {
          this.runner = window.setTimeout(() => {
            let direction = directions[position];
            this.positionClass = `dropdown-position-${position}`;
            this.visible = true;
            this.$nextTick(() => {
              this.$emit("show", event);
              this.$nextTick(() => {
                let position = this.getDropdownPosition(target, this.$refs.dropdown, direction);
                this.position = {
                  left: `${position.left + this.paddingLeft}px`,
                  top: `${position.top}px`
                };
              });
            });
          }, delay || this.delay);
        }
      });
    },
    hideEventListener(event) {
      window.clearTimeout(this.runner);
      if (this.visible) {
        this.visible = false;
        this.$emit("hide", event);
      }
    },
    getDropdownPosition(target, dropdown, direction) {
      if (!dropdown) return {
        left: 0,
        top: 0,
      };
      let trRect = target.getBoundingClientRect();
      let ddRect = dropdown.getBoundingClientRect();
      // Scroll offset of the current document
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
      // Position within the parent
      let offsetLeft = trRect.left + scrollLeft;
      let offsetTop = trRect.top + scrollTop;
      // let shiftX = ddRect.width - trRect.width
      let shiftY = 0.5 * (ddRect.height + trRect.height);
      // Center of the target element
      let centerX = offsetLeft - 0.5 * (ddRect.width - trRect.width);
      let centerY = offsetTop + trRect.height - shiftY;
      // let anchorX = direction[0] * this.anchor
      // let anchorY = direction[0] * this.anchor
      // Position of the dropdown relatively to target
      let x = direction[0] * 0.5 * (ddRect.width + trRect.width);
      let y = direction[1] * shiftY;
      // Pointer size correction
      if (this.pointer) {
        x += direction[0] * pointerSize;
        y += direction[1] * pointerSize;
      }
      return {
        left: centerX + x,
        top: centerY - y
      };
    }
  },
  render: function(createElement) {
    if (!this.visible) {
      return;
    }
    return createElement(
      "div",
      {
        class: this.className,
        style: this.style,
        attrs: {
          "data-popover": this.name
        },
        on: {
          click: event => event.stopPropagation()
        },
        ref: "dropdown"
      },
      this.$slots.default
    );
  }
};
</script>

<style lang="scss">
$pointer-size: 4px;
.vue-popover {
  display: block;
  position: absolute;
  background: #fff;
  // box-shadow: 0px 4px 20px 0px rgba(52, 73, 94, 0.2);
  padding: 4px 8px;
  border-radius: $radius;
  transition: opacity 0.5s ease;

  z-index: 999999999999999999;
  &:before {
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    content: "";
  }
  &[data-popover$="tooltipProductCard"] {
    left:  calc(50% - #{$pointer-size} - 60px) !important;
    &::before {
      left: calc(90% - #{$pointer-size}) !important;
    }
  }
  &[data-popover$="tooltip"], &[data-popover$="tooltipPricing"], &[data-popover$="tooltipProductCard"] {
    max-width: 190px;
    color: $textDarkModeHigh;
    padding: 3px 8px;
    font-size: 12px;
    line-height: 18px;
    background: $dark1;
    border-radius: $radius;
    &.dropdown-position-bottom:before {
      border-bottom: $pointer-size solid $dark1;
    }
    &.dropdown-position-bottomsidebar {
      margin-top: 8px;
      &:before {
        border-bottom: $pointer-size solid $dark1;
      }
    }
    &.dropdown-position-top:before {
      border-top: $pointer-size solid $dark1;
    }
    &.dropdown-position-left:before {
      border-left: $pointer-size solid $dark1;
    }
    &.dropdown-position-right:before {
      border-right: $pointer-size solid $dark1;
    }

    &.dropdown-position-rightPricing {
      background: map-get($text-light-mode, "low-contrast");
      border-radius: 4px;
      padding: 8px;
      color: map-get($hybrid-shade-light, "100");
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      &:before {
        border-right: $pointer-size solid map-get($text-light-mode, "low-contrast") !important;
      }
    }
  }
  &.dropdown-position-bottom:before,
  &.dropdown-position-bottomsidebar:before {
    border-left: $pointer-size solid transparent;
    border-right: $pointer-size solid transparent;
    border-bottom: $pointer-size solid $dark1;
    top: -$pointer-size;
    left: calc(50% - #{$pointer-size});
    // filter: drop-shadow(0px -2px 2px rgba(52, 73, 94, 0.1));
  }
  &.dropdown-position-top:before {
    border-left: $pointer-size solid transparent;
    border-right: $pointer-size solid transparent;
    border-top: $pointer-size solid $dark1;
    bottom: -$pointer-size;
    left: calc(50% - #{$pointer-size});
    // filter: drop-shadow(0px 2px 2px rgba(52, 73, 94, 0.1));
  }
  &.dropdown-position-left:before {
    border-top: $pointer-size solid transparent;
    border-bottom: $pointer-size solid transparent;
    border-left: $pointer-size solid $dark1;
    right: -$pointer-size;
    top: calc(50% - #{$pointer-size});
    // filter: drop-shadow(2px 0px 2px rgba(52, 73, 94, 0.1));
  }
  &.dropdown-position-right:before,
  &.dropdown-position-rightPricing:before {
    border-top: $pointer-size solid transparent;
    border-bottom: $pointer-size solid transparent;
    border-right: $pointer-size solid $dark1;
    left: -$pointer-size;
    top: calc(50% - #{$pointer-size});
    // filter: drop-shadow(-2px 0px 2px rgba(52, 73, 94, 0.1));
  }
}
</style>
